import React, { Component } from 'react'
import PT from 'prop-types'
import axios from 'axios'
import { isEmpty } from 'ramda'
import { withRouter } from 'react-router-dom'
import { POST_DETAIL_URL, POST_DETAIL_URL_89 } from '../constants'
import { typeFromProps, idFromUrl } from '../components/Post/helpers'
import { filterInvalidImages } from '../helpers'

const withPostDetail = WrappedComponent =>
  withRouter(class Container extends Component {
    static propTypes = {
      match: PT.shape({
        params: PT.shape({
          slug: PT.string.isRequired,
        }).isRequired,
      }).isRequired,
      location: PT.shape({
        pathname: PT.string.isRequired,
      }).isRequired,
    }

    state = {}

    componentDidMount() {
      const { slug } = this.props.match.params
      const urlStart = this.props.location.pathname.startsWith('/89')
        ? POST_DETAIL_URL_89
        : POST_DETAIL_URL

      console.log(`${urlStart}${slug}`)

      axios
        .get(`${urlStart}${slug}`)
        .then((res) => {
          const data = res.data[0]
          const filtered = {
            ...data,
            images: filterInvalidImages(data.images),
          }
          this.setState(filtered)
        })
        .catch((error) => {
          if (window.Raven) {
            window.Raven.captureException(error, { extra: 'fetch post detail error' })
          }
        })
    }

    render() {
      const { state } = this
      if (isEmpty(state)) return 'Loading...'

      const id = state.youtube && idFromUrl(state.youtube)
      const type = typeFromProps(state)

      return (
        <WrappedComponent
          {...this.state}
          id={id}
          type={type}
        />
      )
    }
  })

export default withPostDetail



// WEBPACK FOOTER //
// ./src/hoc/withPostDetail.js